/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FuelUpVaultActionResponseEvolutionResult
 */
export interface FuelUpVaultActionResponseEvolutionResult {
    /**
     * 
     * @type {boolean}
     * @memberof FuelUpVaultActionResponseEvolutionResult
     */
    evolved?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FuelUpVaultActionResponseEvolutionResult
     */
    newTier?: string;
    /**
     * 
     * @type {number}
     * @memberof FuelUpVaultActionResponseEvolutionResult
     */
    bonusReceived?: number;
}

/**
 * Check if a given object implements the FuelUpVaultActionResponseEvolutionResult interface.
 */
export function instanceOfFuelUpVaultActionResponseEvolutionResult(value: object): value is FuelUpVaultActionResponseEvolutionResult {
    return true;
}

export function FuelUpVaultActionResponseEvolutionResultFromJSON(json: any): FuelUpVaultActionResponseEvolutionResult {
    return FuelUpVaultActionResponseEvolutionResultFromJSONTyped(json, false);
}

export function FuelUpVaultActionResponseEvolutionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): FuelUpVaultActionResponseEvolutionResult {
    if (json == null) {
        return json;
    }
    return {
        
        'evolved': json['evolved'] == null ? undefined : json['evolved'],
        'newTier': json['newTier'] == null ? undefined : json['newTier'],
        'bonusReceived': json['bonusReceived'] == null ? undefined : json['bonusReceived'],
    };
}

export function FuelUpVaultActionResponseEvolutionResultToJSON(json: any): FuelUpVaultActionResponseEvolutionResult {
    return FuelUpVaultActionResponseEvolutionResultToJSONTyped(json, false);
}

export function FuelUpVaultActionResponseEvolutionResultToJSONTyped(value?: FuelUpVaultActionResponseEvolutionResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'evolved': value['evolved'],
        'newTier': value['newTier'],
        'bonusReceived': value['bonusReceived'],
    };
}

